import styled from 'styled-components';

const StyledLayoutTable = styled.ul`
	position: relative;
	width: 300px;
	height: calc(100% - 44px);
	row-gap: 12px;
	overflow-y: auto;

	& > :not(:last-child) {
		margin-bottom: 12px;
	}
`;

export { StyledLayoutTable };
